export default __webpack_public_path__ + "assets/b04074afcdbe92b0666c331483f36c3f.svg";